var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4683 15.5H2.63362C2.22431 15.5 1.86316 15.1629 1.86316 14.7295V1.17416C1.86316 0.813002 2.15208 0.5 2.53732 0.5H9.23074C9.49558 0.5 9.71228 0.716693 9.71228 0.981541C9.71228 1.24639 9.49558 1.46308 9.23074 1.46308H2.85032V14.5369H13.372V5.29133C13.372 5.02648 13.5887 4.80979 13.8535 4.80979C14.1184 4.80979 14.3351 5.02648 14.3351 5.29133V14.6573C14.311 15.1148 13.9498 15.5 13.4683 15.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44746 5.89326C9.25484 5.89326 9.0863 5.82103 8.96592 5.70064C8.82145 5.55618 8.74922 5.36356 8.74922 5.09872V1.15008C8.74922 1.00562 8.74922 0.692616 9.06222 0.548154C9.27892 0.451846 9.47153 0.5 9.68823 0.692616L14.0943 4.80979C14.2869 5.00241 14.3592 5.24318 14.2869 5.48395C14.1906 5.72472 13.9739 5.86918 13.685 5.86918L9.44746 5.89326ZM9.7123 2.04093V4.93018L12.7942 4.9061L9.7123 2.04093Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13447 9.33655H4.55983C4.29499 9.33655 4.07829 9.11986 4.07829 8.85501C4.07829 8.59016 4.29499 8.37347 4.55983 8.37347H9.13447C9.39932 8.37347 9.61601 8.59016 9.61601 8.85501C9.61601 9.11986 9.39932 9.33655 9.13447 9.33655ZM7.49723 6.4473H4.55983C4.29499 6.4473 4.07829 6.23061 4.07829 5.96576C4.07829 5.70092 4.29499 5.48422 4.55983 5.48422H7.47316C7.738 5.48422 7.9547 5.70092 7.9547 5.96576C7.9547 6.23061 7.76208 6.4473 7.49723 6.4473ZM10.6995 12.2499H4.55983C4.29499 12.2499 4.07829 12.0332 4.07829 11.7683C4.07829 11.5035 4.29499 11.2868 4.55983 11.2868H10.6995C10.9643 11.2868 11.181 11.5035 11.181 11.7683C11.181 12.0332 10.9643 12.2499 10.6995 12.2499Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestRecord);
export default __webpack_public_path__ + "static/media/test-record.12d9719dddd663e092fdcd4617c478b1.svg";
export { ForwardRef as ReactComponent };